<template>
  <div class="collapseHandleTxt  mt-4">
    <div>Changer pour ce titre</div>
    <div class="radioInput controlCard control-checkbox">
      <input type="checkbox" checked="checked" />
      <div class="control_indicator"></div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
.collapseHandleTxt {
  text-align: right;
  font: normal normal normal $mf_ft_size_subtitle Segoe UI;
  letter-spacing: 0px;
  color: $mf_ft_color_white;
  opacity: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  .controlCard {
    font-family: arial;
    display: block;
    position: relative;
    margin-left: 0px;
    margin-bottom: 5px;
    margin: initial;
    width: fit-content;
    padding-top: 3px;
    cursor: pointer;
    font-size: 16px;
  }
  .controlCard input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control_indicator {
    $size: 30px;
    position: relative;
    top: 0px;
    left: 0;
    height: $size;
    margin-left: 15px;
    width: $size;
    background: transparent;
    border: 2px solid $purple_color;
    border-radius: 20px;
  }
  .controlCard:hover input ~ .control_indicator,
  .controlCard input:focus ~ .control_indicator {
    background: $purple_color;
  }

  .controlCard input:checked ~ .control_indicator {
    background: $purple_color;
  }
  .controlCard:hover input:not([disabled]):checked ~ .control_indicator,
  .controlCard input:checked:focus ~ .control_indicator {
    background: $purple_color;
  }
  .controlCard input:disabled ~ .control_indicator {
    background: #e6e6e6;
    opacity: 0.6;
    pointer-events: none;
  }
  .control_indicator:after {
    box-sizing: unset;
    content: "";
    position: absolute;
    display: none;
  }
  .controlCard input:checked ~ .control_indicator:after {
    display: block;
  }
  .control-checkbox .control_indicator:after {
    left: 10px;
    top: 5px;
    width: 5px;
    height: 12px;
    border: solid #ffffff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
  .control-checkbox input:disabled ~ .control_indicator:after {
    border-color: white;
  }
  //   .control-checkbox .control_indicator::before {
  //     content: "";
  //     display: block;
  //     position: absolute;
  //     left: 0;
  //     top: 0;
  //     width: 4.935rem;
  //     height: 4.5rem;
  //     margin-left: -1.3rem;
  //     margin-top: -1.3rem;
  //     background: $purple_color;
  //     border-radius: 3rem;
  //     opacity: 0.6;
  //     z-index: 99999;
  //   }
}
</style>
